import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderItemStatus } from './Enums'
/**
* Class StatusInfoOfOrderItemStatus
*  Информация о статусе
*/
export class StatusInfoOfOrderItemStatus extends ActiveModel {

  /**
  * status
  * словарь значений публикуется под именем `Domain.Entities.Orders.OrderItemStatus`  *   * Значение статуса<br>  *   * - `Calculated` Ожидает оплаты  *   * Ожидает оплаты  * - `Payment` В процессе оплаты  *   * В процессе оплаты  * - `Collection` Собирается  *   * В процессе сбора  * - `Delivery` В процессе доставки  *   * В процессе доставки  * - `Receiving` Ожидает получения  *   * Ожидает получения  * - `Completing` Ожидает завершения  *   * В процессе ожидания завершения  * - `Cancelled` Отменён  *   * Отменён  * - `Completed` Завершён  *   * Завершён  *   */
  @ActiveField(OrderItemStatus.CALCULATED)
  status: OrderItemStatus = OrderItemStatus.CALCULATED


/**
  * assignedAt
  * Время назначения статуса<br>
  */
  @ActiveField('')
  assignedAt: string = ''
}
